var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/elements/window.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"parent")?runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"parent")),"element")),"offsetLeft") + 20 || 0:0);
frame.set("xpos", t_1, true);
if(frame.topLevel) {
context.setVariable("xpos", t_1);
}
if(frame.topLevel) {
context.addExport("xpos", t_1);
}
output += "\r\n";
var t_2;
t_2 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"parent")?runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"parent")),"element")),"offsetTop") + 20 || 0:0);
frame.set("ypos", t_2, true);
if(frame.topLevel) {
context.setVariable("ypos", t_2);
}
if(frame.topLevel) {
context.addExport("ypos", t_2);
}
output += "\r\n<div class=\"window";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"parent")?" child":" parent"), env.opts.autoescape);
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"parent")),"sub")),"dummy")?" dummy":""), env.opts.autoescape);
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"renderOptions")),"inactive")?" inactive":""), env.opts.autoescape);
output += "\" \r\n\tdata-window-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"id"), env.opts.autoescape);
output += "\" \r\n\t\r\n\tstyle=\"left:";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "xpos"), env.opts.autoescape);
output += ";top:";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "ypos"), env.opts.autoescape);
output += ";min-width: 400px; min-height: 400px; z-index:";
output += runtime.suppressValue((!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"parent")?runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"tabs")),"length"):"1"), env.opts.autoescape);
output += "0; ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"parent") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"parent")),"output")),"Request")),"Prefix") == "Multi"?"height:100%;":""), env.opts.autoescape);
output += "\">\r\n\r\n\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"parent")),"output")),"Request")),"Prefix") != "Multi" || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"sub") != runtime.contextOrFrameLookup(context, frame, "null") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"sub")),"dummy"))) {
output += "\r\n\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"parent") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"parent")),"output")),"Request")),"Prefix") != "Multi") {
output += "\r\n\t<div class=\"tabs sticky-div\">\r\n\t\t<div class=\"window-action-bar\">\r\n\t\t\t<!-- <button class=\"button action material-icons\">&#xe5d2;</button> -->\r\n\t\t\t<button data-window-toggle-fullscreen class=\"button action\" style=\"padding: 2px !important;\" ><i class=\"fad fa-expand-arrows\"></i></button>\r\n\t\t\t<div class=\"dropdown\">\r\n\t\t\t\t<button class=\"button toggle-menu action material-icons\">&#xe5cf;</button>\r\n\r\n\r\n\t\t\t\t<div class=\"menu hide\">\r\n\t\t\t\t\t";
frame = frame.push();
var t_5 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"parent")),"tabs");
if(t_5) {var t_4 = t_5.length;
for(var t_3=0; t_3 < t_5.length; t_3++) {
var t_6 = t_5[t_3];
frame.set("tab", t_6);
frame.set("loop.index", t_3 + 1);
frame.set("loop.index0", t_3);
frame.set("loop.revindex", t_4 - t_3);
frame.set("loop.revindex0", t_4 - t_3 - 1);
frame.set("loop.first", t_3 === 0);
frame.set("loop.last", t_3 === t_4 - 1);
frame.set("loop.length", t_4);
output += "\r\n\t\t\t\t\t<a class=\"option\" data-window-event=\"";
output += runtime.suppressValue(runtime.memberLookup((t_6),"Event"), env.opts.autoescape);
output += "\" data-window-event-preventdefault=\"false\" data-window-target=\"parent\">";
output += runtime.suppressValue(runtime.memberLookup((t_6),"Title"), env.opts.autoescape);
output += "</a>\r\n\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t\t";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"empty")) {
output += "\r\n\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"options")),"noReset") == false) {
output += "<button data-window-event=\"reset\" class=\"button action action-reload material-icons\">&#xe5d5;</button>";
;
}
output += "\r\n\t\t\t";
;
}
output += "\r\n\t\t</div>\r\n\r\n\t\t<div class=\"tab-overflow\">\r\n\t\t\t";
frame = frame.push();
var t_9 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"parent")),"tabs");
if(t_9) {var t_8 = t_9.length;
for(var t_7=0; t_7 < t_9.length; t_7++) {
var t_10 = t_9[t_7];
frame.set("tab", t_10);
frame.set("loop.index", t_7 + 1);
frame.set("loop.index0", t_7);
frame.set("loop.revindex", t_8 - t_7);
frame.set("loop.revindex0", t_8 - t_7 - 1);
frame.set("loop.first", t_7 === 0);
frame.set("loop.last", t_7 === t_8 - 1);
frame.set("loop.length", t_8);
output += "\r\n\t\t\t<a class=\"tab ";
output += runtime.suppressValue((runtime.memberLookup((t_10),"Selected")?"selected":""), env.opts.autoescape);
output += "\" data-window-event=\"";
output += runtime.suppressValue(runtime.memberLookup((t_10),"Event"), env.opts.autoescape);
output += "\" data-window-event-preventdefault=\"false\" data-window-target=\"parent\" >";
output += runtime.suppressValue(runtime.memberLookup((t_10),"Title"), env.opts.autoescape);
output += "</a>";
;
}
}
frame = frame.pop();
output += "\r\n\t\t</div>\r\n\t</div>\r\n\t";
;
}
else {
output += "\r\n\t<div class=\"window-head\">\r\n\t\t<div class=\"window-action-bar\">\r\n\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"options")),"noReset") == false) {
output += "<button data-window-event=\"reset\" class=\"button action action-reload material-icons\">&#xe5d5;</button>";
;
}
output += "\r\n\t\t\t<button data-window-event=\"dispose\" class=\"button action action-close material-icons\">&#xe5cd;</button>\r\n\t\t</div>\r\n\r\n\t\t<div class=\"handle\">";
output += runtime.suppressValue((lineno = 41, colno = 35, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"title"), "window[\"title\"]", context, [])), env.opts.autoescape);
output += "&nbsp;</div>\r\n\t</div>\r\n\t";
;
}
output += "\r\n\t";
;
}
output += "\r\n\r\n\t";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"empty")) {
output += "\r\n\t<div class=\"window-body\">\r\n\t\t<div class=\"scroll-container\">\r\n\t\t\t";
if((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"renderOptions")),"actionbar") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Buttons")),"length") > 0) || runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"kiosk") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"bulkedit")) {
output += "\r\n\t\t\t<div class=\"action-bar sticky-div ";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"kiosk")?"text-center":""), env.opts.autoescape);
output += "\" style=\"z-index: 90;\">\r\n\t\t\t<div data-event=\"openHelpDialogue\" style=\"float:right\" id=\"manual-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"id"), env.opts.autoescape);
output += "\"></div>\r\n\t\t\t\t";
if(!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"kiosk")) {
output += "\r\n\t\t\t\t<div class=\"dropdown\">\r\n\t\t\t\t\t<button class=\"button button-menu toggle-menu material-icons\"><i class=\"fa fa-angle-down\"></i></button>\r\n\t\t\t\t\t<div class=\"menu hide\">\r\n\t\t\t\t\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"bulkedit") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"renderOptions")),"customButtons")) {
output += "\r\n\t\t\t\t\t\t\t<a class=\"option\" data-window-event=\"save-bulk\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Save"), env.opts.autoescape);
output += "</a>\r\n\t\t\t\t\t\t\t<a class=\"option\" data-window-event=\"cancel-bulk\">Annuleren</a>\r\n\t\t\t\t\t\t";
;
}
else {
output += "\r\n\t\t\t\t\t\t\t";
frame = frame.push();
var t_13 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Buttons");
if(t_13) {var t_12 = t_13.length;
for(var t_11=0; t_11 < t_13.length; t_11++) {
var t_14 = t_13[t_11];
frame.set("action", t_14);
frame.set("loop.index", t_11 + 1);
frame.set("loop.index0", t_11);
frame.set("loop.revindex", t_12 - t_11);
frame.set("loop.revindex0", t_12 - t_11 - 1);
frame.set("loop.first", t_11 === 0);
frame.set("loop.last", t_11 === t_12 - 1);
frame.set("loop.length", t_12);
output += "\r\n\t\t\t\t\t\t\t\t<a class=\"option\" data-action-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" data-window-event=\"";
output += runtime.suppressValue(runtime.memberLookup((t_14),"Event"), env.opts.autoescape);
output += "\" title=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_14),"Description")), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_14),"Title")), env.opts.autoescape);
output += "</a>\r\n\t\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t\r\n\t\t\t\t\r\n\t\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Data")),"Columns")) {
output += "\r\n\t\t\t\t<div class=\"column-select dropdown\" style=\"float: right;\">\r\n\t\t\t\t\t";
var t_15;
t_15 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Data") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Data")),"Rows")),"length") == 0 || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"bulkedit");
frame.set("disableColButton", t_15, true);
if(frame.topLevel) {
context.setVariable("disableColButton", t_15);
}
if(frame.topLevel) {
context.addExport("disableColButton", t_15);
}
output += "\r\n\t\t\t\t\t\r\n\t\t\t\t\t\r\n\r\n\t\t\t\t\t<div class=\"button button-menu fake-button ";
output += runtime.suppressValue((!runtime.contextOrFrameLookup(context, frame, "disableColButton")?"toggle-menu":""), env.opts.autoescape);
output += "\" \r\n\t\t\t\t\t\t";
if(runtime.contextOrFrameLookup(context, frame, "disableColButton")) {
output += " \r\n\t\t\t\t\t\t\tdisabled\r\n\t\t\t\t\t\t";
;
}
output += ">\r\n\t\t\t\t\t\t<i class=\"fa fa-columns\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"SelectColumns"), env.opts.autoescape);
output += "\"></i>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t\t<div class=\"menu hide\">\r\n\t\t\t\t\t\t";
frame = frame.push();
var t_18 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"FullTable")),"ColumnsToSelect");
if(t_18) {var t_17 = t_18.length;
for(var t_16=0; t_16 < t_18.length; t_16++) {
var t_19 = t_18[t_16];
frame.set("col", t_19);
frame.set("loop.index", t_16 + 1);
frame.set("loop.index0", t_16);
frame.set("loop.revindex", t_17 - t_16);
frame.set("loop.revindex0", t_17 - t_16 - 1);
frame.set("loop.first", t_16 === 0);
frame.set("loop.last", t_16 === t_17 - 1);
frame.set("loop.length", t_17);
output += "\r\n\t\t\t\t\t\t<label class=\"option composite\" data-window-event=\"toggle-column:";
output += runtime.suppressValue(runtime.memberLookup((t_19),"Name"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t<div class=\"item left\">\r\n\t\t\t\t\t\t\t\t<input type=\"checkbox\" ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Data") && (lineno = 84, colno = 126, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Data")),"HiddenColumns")),"indexOf"), "window[\"output\"][\"Data\"][\"HiddenColumns\"][\"indexOf\"]", context, [runtime.memberLookup((t_19),"Name")])) == -1?"checked":""), env.opts.autoescape);
output += ">\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<!-- <span>";
output += runtime.suppressValue(runtime.memberLookup((t_19),"Title"), env.opts.autoescape);
output += "</span> -->\r\n\t\t\t\t\t\t\t<span>";
if(runtime.memberLookup((t_19),"Title")) {
output += " ";
output += runtime.suppressValue(runtime.memberLookup((t_19),"Title"), env.opts.autoescape);
output += " ";
;
}
else {
output += " ";
output += runtime.suppressValue(runtime.memberLookup((t_19),"Name"), env.opts.autoescape);
output += " ";
;
}
output += "</span>\r\n\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t";
;
}
output += "\r\n\t\t\t\t";
;
}
output += "\r\n\r\n\t\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"kiosk")) {
output += "\r\n\t\t\t\t<button class=\"button button-default\" data-window-event=\"dispose\" style=\"float: left\">&laquo; Terug</button>\r\n\t\t\t\t";
;
}
output += "\r\n\r\n\t\t\t\t<div class=\"buttons\" ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"kiosk")) {
output += " style=\"float: right\"";
;
}
output += ">\r\n\t\t\t\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"bulkedit") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"renderOptions")),"customButtons")) {
output += "\r\n\t\t\t\t\t\t<button class=\"button button-default\" data-window-event=\"save-bulk\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"Save"), env.opts.autoescape);
output += "</button>\r\n\t\t\t\t\t\t<button class=\"button button-default\" data-window-event=\"cancel-bulk\">Annuleren</button>\r\n\t\t\t\t\t";
;
}
else {
output += "\r\n\t\t\t\t\t\t";
frame = frame.push();
var t_22 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Buttons");
if(t_22) {var t_21 = t_22.length;
for(var t_20=0; t_20 < t_22.length; t_20++) {
var t_23 = t_22[t_20];
frame.set("action", t_23);
frame.set("loop.index", t_20 + 1);
frame.set("loop.index0", t_20);
frame.set("loop.revindex", t_21 - t_20);
frame.set("loop.revindex0", t_21 - t_20 - 1);
frame.set("loop.first", t_20 === 0);
frame.set("loop.last", t_20 === t_21 - 1);
frame.set("loop.length", t_21);
output += "\t\t\t\t\t\t\t\r\n\t\t\t\t\t\t\t";
if(runtime.memberLookup((t_23),"ActionName") === "OpenExcelFileInput") {
output += "<label for=\"ExcelFileCatcher-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"id"), env.opts.autoescape);
output += "\" class=\"button button-default custom-file-upload\"> ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_23),"Icon")), env.opts.autoescape);
output += " <span class=\"d-none d-lg-inline-block d-xl-inline-block\">";
output += runtime.suppressValue(runtime.memberLookup((t_23),"Title"), env.opts.autoescape);
output += "</span>\r\n\t\t\t\t\t\t\t\t\t<input type=\"file\" id=\"ExcelFileCatcher-";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"id"), env.opts.autoescape);
output += "\" data-action-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\"\r\n\t\t\t\t\t\t\t\t\tdata-window-event-preventdefault=\"false\" data-window-event=\"";
output += runtime.suppressValue(runtime.memberLookup((t_23),"Event"), env.opts.autoescape);
output += "\"\r\n\t\t\t\t\t\t\t\t\taccept=\".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel\"/>\r\n\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t";
;
}
else {
if(runtime.memberLookup((t_23),"Icon")) {
output += "\r\n\t\t\t\t\t\t\t\t<button class=\"button button-default\" data-action-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" data-window-event=\"";
output += runtime.suppressValue(runtime.memberLookup((t_23),"Event"), env.opts.autoescape);
output += "\" title=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_23),"Description")), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_23),"Icon")), env.opts.autoescape);
output += " <span class=\"d-none d-lg-inline-block d-xl-inline-block\">";
output += runtime.suppressValue(runtime.memberLookup((t_23),"Title"), env.opts.autoescape);
output += "</span></button>";
;
}
else {
output += "<button class=\"button button-default\" data-action-id=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" data-window-event=\"";
output += runtime.suppressValue(runtime.memberLookup((t_23),"Event"), env.opts.autoescape);
output += "\" title=\"";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_23),"Description")), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_23),"Title"), env.opts.autoescape);
output += "</button>\r\n\t\t\t\t\t\t\t";
;
}
;
}
output += "\r\n\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t</div>\r\n\t\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"kiosk")) {
output += "\r\n\t\t\t\t<strong style=\"font-size: 24px\">";
output += runtime.suppressValue((lineno = 117, colno = 49, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"title"), "window[\"title\"]", context, [])), env.opts.autoescape);
output += "</strong>\r\n\t\t\t\t";
;
}
output += "\r\n\t\t\t</div>\r\n\t\t\t";
;
}
output += "\r\n\r\n\t\t\t<!--<button class=\"make-sticky button button-default\">Stick</button>-->\r\n\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Request")),"Prefix") == "Multi") {
output += "\r\n\t\t\t<div class=\"row no-gutters multi-row\">\r\n\t\t\t\t<div class=\"col col-xs-12 ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "childrenHtml")),"length") > 0?"col-sm-6 col-md-4":""), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t<div class=\"window-content mb-0\">\r\n\t\t\t\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"WindowDescription") != runtime.contextOrFrameLookup(context, frame, "null")) {
output += "\r\n\t\t\t\t\t\t\t<div class=\"alert alert-primary mb-0\">\r\n\t\t\t\t\t\t\t\t<p><i class=\"fa fa-info\"></i>&nbsp; ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"WindowDescription")), env.opts.autoescape);
output += "</p>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t\t";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "body")), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t<div class=\"overlay";
output += runtime.suppressValue((!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"renderOptions")),"overlay")?" hide":""), env.opts.autoescape);
output += "\"></div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "childrenHtml")),"length") > 0) {
output += "\r\n\t\t\t\t<div class=\"col col-xs-12 col-md-8 col-sm-6 panel left-border\">\r\n\t\t\t\t\t";
frame = frame.push();
var t_26 = runtime.contextOrFrameLookup(context, frame, "childrenHtml");
if(t_26) {var t_25 = t_26.length;
for(var t_24=0; t_24 < t_26.length; t_24++) {
var t_27 = t_26[t_24];
frame.set("childHtml", t_27);
frame.set("loop.index", t_24 + 1);
frame.set("loop.index0", t_24);
frame.set("loop.revindex", t_25 - t_24);
frame.set("loop.revindex0", t_25 - t_24 - 1);
frame.set("loop.first", t_24 === 0);
frame.set("loop.last", t_24 === t_25 - 1);
frame.set("loop.length", t_25);
output += "\r\n\t\t\t\t\t\t";
output += runtime.suppressValue(env.getFilter("safe").call(context, t_27), env.opts.autoescape);
output += "\r\n\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t</div>\r\n\t\t\t\t";
;
}
output += "\r\n\t\t\t</div>\r\n\r\n\t\t\t";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Request")),"Prefix")) {
output += "\r\n\t\t\t<div class=\"window-content\">\r\n\t\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"WindowDescription") != runtime.contextOrFrameLookup(context, frame, "null")) {
output += "\r\n\t\t\t\t\t<div class=\"alert alert-primary mb-0\">\r\n\t\t\t\t\t\t<p><i class=\"fa fa-info\"></i>&nbsp; ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"WindowDescription")), env.opts.autoescape);
output += "</p>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t";
;
}
output += "\r\n\t\t\t\t";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "body")), env.opts.autoescape);
output += "\r\n\t\t\t\t<div class=\"overlay";
output += runtime.suppressValue((!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"renderOptions")),"overlay")?" hide":""), env.opts.autoescape);
output += "\"></div>\r\n\t\t\t</div>\r\n\t\t\t\t";
frame = frame.push();
var t_30 = runtime.contextOrFrameLookup(context, frame, "childrenHtml");
if(t_30) {var t_29 = t_30.length;
for(var t_28=0; t_28 < t_30.length; t_28++) {
var t_31 = t_30[t_28];
frame.set("childHtml", t_31);
frame.set("loop.index", t_28 + 1);
frame.set("loop.index0", t_28);
frame.set("loop.revindex", t_29 - t_28);
frame.set("loop.revindex0", t_29 - t_28 - 1);
frame.set("loop.first", t_28 === 0);
frame.set("loop.last", t_28 === t_29 - 1);
frame.set("loop.length", t_29);
output += "\r\n\t\t\t\t";
output += runtime.suppressValue(env.getFilter("safe").call(context, t_31), env.opts.autoescape);
output += "\r\n\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t";
;
}
else {
output += "\r\n\t\t\t<div class=\"window-content\">\r\n\t\t\t\t";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.contextOrFrameLookup(context, frame, "body")), env.opts.autoescape);
output += "\r\n\t\t\t\t<div class=\"overlay";
output += runtime.suppressValue((!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"renderOptions")),"overlay")?" hide":""), env.opts.autoescape);
output += "\"></div>\r\n\t\t\t</div>\r\n\t\t\t";
frame = frame.push();
var t_34 = runtime.contextOrFrameLookup(context, frame, "childrenHtml");
if(t_34) {var t_33 = t_34.length;
for(var t_32=0; t_32 < t_34.length; t_32++) {
var t_35 = t_34[t_32];
frame.set("childHtml", t_35);
frame.set("loop.index", t_32 + 1);
frame.set("loop.index0", t_32);
frame.set("loop.revindex", t_33 - t_32);
frame.set("loop.revindex0", t_33 - t_32 - 1);
frame.set("loop.first", t_32 === 0);
frame.set("loop.last", t_32 === t_33 - 1);
frame.set("loop.length", t_33);
output += "\r\n\t\t\t";
output += runtime.suppressValue(env.getFilter("safe").call(context, t_35), env.opts.autoescape);
output += "\r\n\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\r\n\t\t\t";
;
}
;
}
output += "\r\n\t\t</div>\r\n\r\n\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"error")) {
output += "\r\n\t\t<div class=\"cover dim v-center\">\r\n\t\t\t<div class=\"msg-box-holder\">\r\n\t\t\t\t<div class=\"msg-box error\">\r\n\t\t\t\t\t<img src=\"/App_Themes/images/error.svg\">\r\n\t\t\t\t\t<h1 class=\"msg-header\"><span class=\"msg-header-text\">Error</span></h1>\r\n\t\t\t\t\t<p class=\"msg-text\">";
output += runtime.suppressValue((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"error")),"data") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"error")),"data")),"Data") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"error")),"data")),"Data")),"Translation")?runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"error")),"data")),"Data")),"Translation"):"Er is een error opgetreden bij het opvragen van de gegevens."), env.opts.autoescape);
output += "</p>\r\n\r\n\t\t\t\t\t<div class=\"msg-actions\">\r\n\t\t\t\t\t\t<button class=\"button button-default left\" data-window-event=\"reload\">Opnieuw proberen</button>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t";
;
}
output += "\r\n\r\n\t\t<div class=\"loading cover dim v-center ";
output += runtime.suppressValue((!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"loading") || (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"parent") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"parent")),"loading"))?"hide":""), env.opts.autoescape);
output += "\">\r\n\t\t\t<div>\r\n\t\t\t\t<div class=\"loading-spinner\">\r\n\t\t\t\t";
output += "\r\n\t\t\t\t";
frame = frame.push();
var t_38 = [0,1,2,3,4];
if(t_38) {var t_37 = t_38.length;
for(var t_36=0; t_36 < t_38.length; t_36++) {
var t_39 = t_38[t_36];
frame.set("x", t_39);
frame.set("loop.index", t_36 + 1);
frame.set("loop.index0", t_36);
frame.set("loop.revindex", t_37 - t_36);
frame.set("loop.revindex0", t_37 - t_36 - 1);
frame.set("loop.first", t_36 === 0);
frame.set("loop.last", t_36 === t_37 - 1);
frame.set("loop.length", t_37);
output += "\r\n\t\t\t\t\t<div class=\"loading-dot dot-";
output += runtime.suppressValue(t_39, env.opts.autoescape);
output += "\"></div>\r\n\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t</div>\r\n\t\t\t\t";
output += "\r\n\t\t\t</div>\r\n\t\t</div>\r\n\r\n\t\t<div class=\"upload-info-box cover dim v-center hide\">\r\n\t\t\t<div>\r\n\t\t\t\t<span>Upload file</span>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n\t";
;
}
output += "\r\n\r\n\t";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"parent")) {
output += "\r\n\t\t<div class=\"resize-handle\" style=\"position: absolute; right: -5px; top: 0; bottom: 0; width: 5px; cursor: w-resize;\">\r\n\t\t\t<div data-resize-mode=\"width\" style=\"width: 5px; height: 100%;\"></div>\r\n\t\t</div>\r\n\t\t\r\n\t\t<div class=\"resize-handle\" style=\"position: absolute; bottom: -5px; left: 0; right: 0; height: 5px; cursor: n-resize;\">\r\n\t\t\t<div data-resize-mode=\"height\" style=\"width: 100%; height: 5px;\"></div>\r\n\t\t</div>\r\n\r\n\t\t<div class=\"resize-handle\" style=\"position: absolute; right: -5px; bottom: -5px; width: 5px; height: 5px; cursor: se-resize;\">\r\n\t\t\t<div data-resize-mode=\"both\" style=\"width: 5px; height: 5px;\"></div>\r\n\t\t</div>\r\n\t";
;
}
output += "\r\n</div>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/elements/window.html"] , dependencies)